import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const adsCampaignsApi = 'http://localhost:5551'

export const campaignsApi = createApi({

  reducerPath: 'campaignsApi',

  baseQuery: fetchBaseQuery({
    baseUrl: `${adsCampaignsApi}/`,
  }),

  tagTypes: ['Campaigns'],
  refetchOnMountOrArgChange: 1,
  keepUnusedDataFor: 86400000,

  endpoints: (builder) => ({

    campaigns: builder.query({
      query: (data) => {
        return {
          url: `api/ads/campaigns?country=${data.countryCode}&domain=${data.domain}`,
          method: 'GET',
          headers: {
            'Country-Code': data.countryCode,
            'Domain-Name': data.domain,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      keepUnusedDataFor: 86400000,
      providesTags: ['Campaigns'],
    }),


  }),

})

export const { useCampaignsQuery } = campaignsApi